module.exports = __webpack_public_path__ + "img/wrainr.3db1dda2.png";